import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';
import { dateFormatter } from '../../../../../utils';

const styles = StyleSheet.create({
  columnHeader: {
    marginTop: '2%',
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '13.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  tableCell: {
    fontSize: 10
  },
  columnContent: {
    width: '15%',
    padding: 7,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const PatientRegistrationInvoicePrint = ({ data }) => {
  console.log(data);
  const calculateBalance = (total, recd) => {
    return total - recd;
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const ageString = data.age;
  const years = ageString.match(/\d+Y/); // This will match digits followed by "Y"

  const user = JSON.parse(localStorage.getItem('user'));
  const currentDate = new Date();
  // Get date components
  const day = currentDate.getDate().toString().padStart(2, '0');
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
  const year = currentDate.getFullYear();

  // Get time components
  const hours = currentDate.getHours().toString().padStart(2, '0');
  const minutes = currentDate.getMinutes().toString().padStart(2, '0');
  const seconds = currentDate.getSeconds().toString().padStart(2, '0');

  return (
    <PDFViewer width="100%" height="100%" showToolbar>
      <Document title={`Invoice Print ${data.name}`}>
        <Page size="A4" style={styles.page}>
          <PDFImage
            src="/logo_Hospital_m.jpeg"
            style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
          />
          <View style={styles.row}>
            <Text content="OPD Consultancy Detailed Receipt" style={{ fontSize: '12px', margin: '0 auto' }} />
          </View>
          <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="UHID NO.    :  " style={{ fontSize: 10, fontWeight: 'bold' }} />
                <Text content={`${data.uhid}`} />
              </View>
              <View style={styles.row}>
                <Text content="OP No.        :  " style={{ fontSize: 10 }} />
                <Text content={`${data.op_no}`} />
              </View>
              <View style={styles.row}>
                <Text content="Date/Time   :  " style={{ fontSize: 10 }} />
                <Text content={`${formatDate(data?.reg_date)} ${data?.reg_time}`} />
              </View>
              <View style={styles.row}>
                <Text content="Address      :  " style={{ fontSize: 10 }} />
                <Text content={`${data.address}`} style={{ width: '100' }} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Patient Name :  " style={{ fontSize: 10 }} />
                <Text content={`${data.name}`} />
              </View>
              <View style={styles.row}>
                <Text content="Age/Sex            :  " />
                <Text content={`${years} / ${data.gender}`} />
              </View>
              <View style={styles.row}>
                <Text content="Mobile No.      :  " style={{ fontSize: 10 }} />
                <Text content={`${data.mobile}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Consultant     :  " style={{ fontSize: 10 }} />
                <Text content={`${data.consultant}`} />
              </View>
              <View style={styles.row}>
                <Text content="Department   :  " style={{ fontSize: 10 }} />
                <Text content={`${data.department}`} />
              </View>
              <View style={styles.row}>
                <Text content="Sponsor         :  " style={{ fontSize: 10 }} />
                <Text content={`${data.sponsor}`} />
              </View>
              <View style={styles.row}>
                <Text content="Token No.       :  " style={{ fontSize: 10 }} />
                <Text content={`${data.token_no}`} />
              </View>
            </View>
          </View>

          <View style={styles.row}>
            <Text style={{ ...styles.columnHeader, width: '7%' }} content="Sr. No." />
            <Text style={{ ...styles.columnHeader, width: '20%' }} content="Services" />
            <Text style={styles.columnHeader} content="Qty." />
            <Text style={styles.columnHeader} content="Rate" />
            <Text style={styles.columnHeader} content="Amount" />
            <Text style={styles.columnHeader} content="Disc." />
            <Text style={styles.columnHeader} content="Net Amount" />
          </View>

          <View style={{ ...styles.row, backgroundColor: 'aliceblue' }}>
            <Text style={{ ...styles.columnContent, width: '7%' }} content={1} />
            <Text style={{ ...styles.columnContent, width: '20%', textAlign: 'left' }} content="Consultancy Charge" />
            <Text style={styles.columnContent} content={1} />
            <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={data.reg} />
            <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={data.opd_fee} />
            <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={data.disc} />
            <Text
              style={{ ...styles.columnContent, textAlign: 'right', marginRight: '10px' }}
              content={data.reg - data.disc}
            />
          </View>
          {data.other_charge !== 0 && (
            <View style={{ ...styles.row, backgroundColor: 'aliceblue' }}>
              <Text style={{ ...styles.columnContent, width: '7%' }} content={2} />
              <Text style={{ ...styles.columnContent, width: '20%', textAlign: 'left' }} content="File Charge" />
              <Text style={styles.columnContent} content={1} />
              <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={data.other_charge} />
              <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={data.other_charge} />
              <Text style={{ ...styles.columnContent, textAlign: 'right' }} content={0} />
              <Text
                style={{ ...styles.columnContent, textAlign: 'right', marginRight: '10px' }}
                content={data.other_charge}
              />
            </View>
          )}

          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Total Amount   :   " style={styles.textBold} />
                <Text content={`${data.reg + data.other_charge}`} />
              </View>
              <View style={styles.row}>
                <Text content="Net Amt           :   " style={styles.textBold} />
                <Text content={`${data.reg + data.other_charge - data?.disc}`} />
              </View>
              <View style={styles.row}>
                <Text content="Discount Name    :   " style={styles.textBold} />
                <Text content={`${data.discount_name}`} />
              </View>
              <View style={{ ...styles.row, marginTop: '8%', width: '280px' }}>
                <Text content={`Recieved With Thanks From ${data.name}`} />
              </View>
              <View style={{ ...styles.row, marginTop: '1%', width: '320px', fontWeight: 'bold' }}>
                <Text
                  style={{ ...styles.row, width: '320px', fontWeight: 'bold' }}
                  content={`Note : Refund, If, any will be made against surrender of Original Receipt only ! `}
                />
              </View>
              <View style={{ ...styles.row, width: '400px', fontWeight: 'bold' }}>
                <Text
                  style={{ ...styles.row, width: '400px', fontWeight: 'bold' }}
                  content={`Printed By : [ ${user.name} ] , Print Date : [ ${day}/${month}/${year} ] , Print Time : [ ${hours}:${minutes}:${seconds} ]`}
                />
              </View>
              {/* <View style={styles.column}>
                <View style={styles.row}>
                  <Text content={`Print Date  :  ${day}/${month}/${year}`} />
                  <Text content={`Print Time  :   ${''}`} />
                </View>
              </View> */}
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Received Amt    :   " />
                <Text content={`${data?.recd}`} />
              </View>
              <View style={styles.row}>
                <Text content="Payment Mode  :   " />
                <Text content={`${data.pay_type}`} />
              </View>
            </View>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Discount        :   " />
                <Text content={`${data.disc}`} />
              </View>
              <View style={styles.row}>
                <Text content="Balance Amt  :   " />
                <Text content={`${calculateBalance(data.total, data.recd, data.other_charge)}`} />
              </View>
              <View style={{ marginTop: '10px' }}>
                <Text content="Recieved By   :" />
                <Text />
              </View>
              <View style={{ marginTop: '5px' }}>
                <Text content="Authorised Signatory  :" />
                <Text />
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};
